export default __webpack_public_path__ + "static/media/vscode.f95272e4.png";